
import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// own module
import { navigationConfig } from '../../config/navigation.config';
import { NavGraph2Component } from '../nav-graph2/nav-graph2';
import { INavGraph2SelResult, NAV_GRAPH_SEL_RESULT_INIT } from '../../model/nav-graph2-sel-result.interface';

const enum SubView {
   HIDE = 0,
   SHOW_SUBVIEW1           = 1 << 1,  // 2
   // exceptions
   DATA_NOT_AVAILABLE      = 1 << 10, // 1024
   INTERNAL_ERROR          = 1 << 11  // 2048
}

@Component({
   selector: 'app-nav-search-mdlg',
   templateUrl: './nav-graph2-mdlg.html',
   styleUrls: ['./nav-graph2-mdlg.scss']
 })
 export class NavGraph2MdlgComponent implements OnInit, OnDestroy, OnChanges {

   // beide Variable entscheiden, ob Selection Button aktiv geschalten wird
   private graph2SelResult: INavGraph2SelResult = NAV_GRAPH_SEL_RESULT_INIT;  // value: zulässige Komponente im Graph2 wurde selektiert
   private isSearchConfigOpen = false;                   // true: searchConfig Dialog ist offen -> Selection Button muß disabled werden
   public enableSelectionButton = false;

   // error
   public _errMsgSubView1 = '';
   public _errMsgSubViewIntErr = '';
   // pages
   private _subView = SubView.HIDE;

   // Observables from store
   @select((s: IAppState) => s.navigationState.elementsResult2stInitial) navElementResultInit$;
   @select((s: IAppState) => s.navigationState.element2stDisplayOptions) navElementOptions$;
   @select((s: IAppState) => s.navigationState.element2stDetail) navElementDetail$;
   @select((s: IAppState) => s.breadcrumbState.crumbSelected0) breadcrumbSelected$;
   @select((s: IAppState) => s.menuState.showNavSearch) showNavSearch$;

   // input
   @Input() public titel = '';
   @Input() public subTitel = '';
   @Input('textSubmitButton') _textSubmitButton = 'AUSWÄHLEN';
   @Input('showCancelButton') _showCancelButton = true;
   @Input('showSubmitButton') _showSubmitButton = true;

   // events
   @Output() cancelEvent = new EventEmitter<null>();
   @Output() submitEvent = new EventEmitter<INavGraph2SelResult>();
   @Output() errorEvent = new EventEmitter<ErrorMessage>();

   // children
   @ViewChild('navGraph2') public readonly navGraph2: NavGraph2Component = null;

   constructor(
   ) { }

   ngOnInit() {
   }

   ngOnDestroy(): void {
      this.onLateDestroy();
   }

   ngOnChanges(): void {
   }

   // ----------------------------------------------------------------------------------------------
   // -- onInit/onDestroy
   // ----------------------------------------------------------------------------------------------
   private onLateInit(
   ): void {
   }
   private onLateDestroy(): void {
      // reset graph2 componente - damit beim nächsten Aufruf ein leerer Graph2 angezeigt wird
      if (!this.navGraph2) {
         return;
      }
      this.navGraph2.reset();
      this.graph2SelResult = NAV_GRAPH_SEL_RESULT_INIT;
      this.isSearchConfigOpen = false;
      this.enableSelectionButton = false;
   }

   // ----------------------------------------------------------------------------------------------
   // -- Error
   // ----------------------------------------------------------------------------------------------
   private showErrMsgSubView1(msg: string): void {
      this._errMsgSubView1 = msg;
      setTimeout(() => {
         this._errMsgSubView1 = '';
      }, appConfig.app.errMsgDurationToShow);
   }

   // ----------------------------------------------------------------------------------------------
   // -- Visibility
   // ----------------------------------------------------------------------------------------------
   public openDialog(
   ): void {
      this.onLateInit();
      this._subView = SubView.SHOW_SUBVIEW1;
   }
   public closeDialog(): void {
      this._subView = SubView.HIDE;
      this.onLateDestroy();
   }
   // Pages
   public showView(): boolean { return this._subView !== SubView.HIDE; }
   public showSubView1(): boolean { return this._subView === SubView.SHOW_SUBVIEW1; }
   // Exceptions
   public showSubViewNoData(): boolean { return this._subView === SubView.DATA_NOT_AVAILABLE; }
   public showSubViewIntErr(): boolean { return this._subView === SubView.INTERNAL_ERROR; }

   // ----------------------------------------------------------------------------------------------
   // -- SubView 1
   // ----------------------------------------------------------------------------------------------
   public onCancelSubPage1() {
      this.closeDialog();
      this.cancelEvent.emit();
   }
   public onSubmitSubPage1() {
      this.closeDialog();
      this.submitEvent.emit(NAV_GRAPH_SEL_RESULT_INIT);
   }

   public onCanSelectKomponent(selectResult: INavGraph2SelResult) {
      this.graph2SelResult = selectResult;
      this.enableSelectionButton = (selectResult !== null);    // null: keine Selektion, sonst Komponent ID z.B. Meldung/1
   }
   public onSearchConfigOpen(isOpen: boolean) {
      this.enableSelectionButton = isOpen ? false : (this.graph2SelResult && this.graph2SelResult.node2Id.length > 0);
   }
   public onSelectionClicked() {
      // sanity - gibt es eine selektierte Komponente?
      if (!this.graph2SelResult || this.graph2SelResult.node2Id.length === 0) {
         console.warn('Keine selektierte Komponente verfügbar');
         return;
      }

      // send
      this.submitEvent.emit(this.graph2SelResult);

      // !! closeDialog resetted Dialog
      this.closeDialog();
   }

   // ----------------------------------------------------------------------------------------------
   // -- Event handler - detail view
   // ----------------------------------------------------------------------------------------------


   // ----------------------------------------------------------------------------------------------
   // -- SubView - Internal Error
   // ----------------------------------------------------------------------------------------------
   public onNextSubViewIntErr() {
      this.closeDialog();
      this.cancelEvent.emit();
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-graph2-mdlg/nav-graph2-mdlg.ts